/* 🤖 this file was generated by svg-to-ts */
export const matIconHorizontalDistribute: {
  name: 'horizontal-distribute';
  data: string;
} = {
  name: 'horizontal-distribute',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 22H2V2h2v20zM22 2h-2v20h2V2zm-8.5 5h-3v10h3V7z"/></svg>`
};
